import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { standardBodyFont } from '../../themes'
import { Label } from './'

const rightPadding = '8px'

const PreTextEditContainer = styled(Label)`
  color: ${props => props.theme.palette.text.disabled};
  padding-right: ${rightPadding};
  white-space: nowrap;
`

/**
 * Implements a PreTextEdit label for the TextEdit component.
 *
 * @param {object} props component props
 * @returns {PreTextEdit} PreTextEdit component
 */
export const PreTextEdit = props => {
  const theme = useTheme()
  return (
    <PreTextEditContainer style={{ ...standardBodyFont(theme) }} {...props} noTranslate={props.noTranslate} theme={theme}>
      {props.children}
    </PreTextEditContainer>
  )
}

PreTextEdit.propTypes = {
  /**
   PreTextEdit label as a child.
   */
  children: PropTypes.string.isRequired,
  /**
   Prevents the language translation of the children pre text edit label.
   */
  noTranslate: PropTypes.bool
}

export default PreTextEdit
